import React from 'react'
import { FormattedMessage } from 'react-intl'
import { getApplicationDrilldownRoute, getServerDrilldownRoute } from '../route'
import { AttackStatus } from '../attack-status'
import { Application, Server } from './shared'
import { Link } from '@contrast-security-inc/design-system-typography'

export interface BlockedOverviewProps {
  readonly result: AttackStatus
  readonly organizationID: string
  readonly application: Application
  readonly server: Server
}

export function AttackEventStatusIndicator({
  result,
  organizationID,
  application,
  server
}: BlockedOverviewProps) {
  if (result === AttackStatus.PROBED) {
    //  a.k.a "isEffective"
    return (
      <FormattedMessage id="detail_attackEventBlocked_attackBlockingNotRequired" />
    )
  } else if (
    result === AttackStatus.BLOCKED ||
    result === AttackStatus.BLOCKED_PERIMETER
  ) {
    return <FormattedMessage id="detail_attackEventBlocked_attackBlocked" />
  } else if (result === AttackStatus.SUSPICIOUS) {
    return (
      <FormattedMessage
        id="detail_attackEventBlocked_suspiciousAttackNotBlocked"
        values={{
          blockStatus: (
            <b>
              <FormattedMessage id="title_ruleModeBlock" />
            </b>
          ),
          monitorStatus: (
            <b>
              <FormattedMessage id="title_attacks_monitor" />
            </b>
          ),
          application: (
            <Link
              href={getApplicationDrilldownRoute(
                organizationID,
                application.id
              )}
            >
              {application.name}
            </Link>
          ),
          server: (
            <Link href={getServerDrilldownRoute(organizationID, server.id)}>
              {server.name}
            </Link>
          )
        }}
      />
    )
  } else {
    return (
      <FormattedMessage
        id="detail_attackEventBlocked_attackNotBlocked"
        values={{
          applicationLink: (
            <Link
              href={getApplicationDrilldownRoute(
                organizationID,
                application.id
              )}
            >
              {application.name}
            </Link>
          ),
          serverLink: (
            <Link href={getServerDrilldownRoute(organizationID, server.id)}>
              {server.name}
            </Link>
          )
        }}
      />
    )
  }
}
